var map = {
	"./internal/skat_matze.png": 2464,
	"./notavailable.png": 1872,
	"./romme.png": 464,
	"./romme_de.png": 3552,
	"./romme_fr.png": 4717,
	"./romme_nl.png": 3384,
	"./rommemasters.png": 2635,
	"./skat.png": 2536,
	"./skatmasters.png": 4549,
	"./zone_selection_badge.png": 6580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8100;